import { NgModule } from '@angular/core';
import { Session } from './session.service';

/**
 * Session Module.
 *
 * @exports
 * @class SessionModule
 */
@NgModule({
  providers: [Session]
})
export class SessionModule {}
